var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.cookieModalVisible)?_c('div',[(_vm.cookieNoticeVisible && _vm.cookieModalVisible)?_c('cookie-notice'):_vm._e(),_vm._v(" "),(_vm.cookieSettingsVisible && _vm.cookieModalVisible)?_c('cookie-settings'):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }